import React from 'react';
import styled from 'styled-components';
import TeamSection from '../sections/TeamSection';



const AboutPage = () => {
  return (
    <AboutContainer>
      {/*    À Propos  */}
      <BackgroundText> À Propos </BackgroundText>

      {/*  Text Propos  */}
      <AboutContent>
        <MainText>
          <span>Nous concevons</span>
          <span>l'expérience</span>
          <span>de conduite de</span>
          <span>demain pour</span>
          <span>un monde durable</span>
        </MainText>

        {/*  Line   */}
        <TopLine>
          <Line />
        </TopLine>

        {/*  Section 2  */}
        <SubHeader>
          Une entreprise guidée par l'excellence technologique
        </SubHeader>

        <DetailText>
          Les ingénieurs de Voltauto fusionnent leurs expertises en ingénierie mécanique et électrique, développement logiciel, architecture de connectivité, gestion de chaîne d'approvisionnement et processus de fabrication innovants pour créer des véhicules d'exception.
        </DetailText>

        {/* 3 Text */}
        <BottomText>
          <BottomTextColumn>
            Grâce à notre maîtrise des matériaux de pointe et à une innovation constante, nous ouvrons la voie à une nouvelle ère de mobilité électrique, alliant performance et durabilité.
          </BottomTextColumn>
          <BottomTextColumn>
            Notre vision nous pousse à réinventer les standards de l’industrie, en développant des solutions technologiques révolutionnaires qui façonnent l’avenir de l’automobile.
          </BottomTextColumn>
          <BottomTextColumn>
            En repoussant les frontières de l’innovation, nous créons des véhicules qui répondent aux défis d’aujourd’hui tout en anticipant les besoins de demain.
          </BottomTextColumn>
        </BottomText>

        {/* Team  */}
        <TeamSection />

      </AboutContent>
    </AboutContainer>
  );
};


export default AboutPage;


const AboutContainer = styled.div`
  min-height: 100vh;
  width: 100%;
  color:  rgba(0, 0, 0, 0.8);
  overflow: hidden;

  @media (max-width: 1024px) {
   justify-content: center;
   align-item: center;
  }
`;

const AboutContent = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  padding: 4rem;
  display: flex;
  justify-content: flex-end;
  flex-direction: column;

  @media (max-width: 1700px) {
    padding: 2rem;
    align-items: flex-start;
  }
`;

const MainText = styled.h1`
  position: relative;
  font-size: clamp(3rem, 8vw, 6.5rem);
  line-height: 1;
  font-weight: 500;
  text-align: right;
  margin: 0;
  max-width: 800px;
  padding-top: 10vh;
  left: 60%;

  span {
    display: block;
    margin-bottom: 0.2em;
    opacity: 0;
    animation: fadeInUp 0.8s ease forwards;

    @for $i from 1 through 5 {
      &:nth-child(#{$i}) {
        animation-delay: #{$i * 0.2}s;
      }
    }
  }

  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(30px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @media (max-width: 1700px) {
    left: 0;
  }

  @media (max-width: 1024px) {
    max-width: 600px;
    left: 0;
  }

  @media (max-width: 768px) {
    text-align: left;
    padding-top: 5vh;
    left: 0;
  }
`;


const BackgroundText = styled.div`
  position: fixed;
  transform: translate(-50%, -50%);
  font-size: 25px; 
  font-weight: 1000; // Plus épais
  color: rgba(0, 0, 0, 0.4);
  white-space: nowrap;
  pointer-events: none;
  z-index: 1; 
  user-select: none;
  text-transform: uppercase;
  letter-spacing: 0.5vw;
  opacity: 0.5;
  top: 10%;
  left : 10vh;

  @media (max-width: 768px) {
    left : 10vh;
    top: 5vh;
    font-size:  25px;  
    max-width: 100%;
  }
`;

// Divider 
const TopLine = styled.div`
  width: 100%;
  padding: 0;
  margin-top: 10%;

  @media (max-width: 768px) {
    margin: 1rem 0 3rem;
  }
`;

const Line = styled.div`
  width: 100%;
  height: 1px;
  background: gray;
`;

// Text Entreprise 
const SubHeader = styled.h2`
  font-size: clamp(1rem, 1.5vw, 1.2rem);
  color: #999;
  font-weight: 400;
  text-align: left;
  margin: 15vh 0 5vh;
  max-width: 800px;
  
  @media (max-width: 768px) {
    text-align: left;
    margin: 10vh 0 5vh;
    max-width: 100%;
  }
`;

const DetailText = styled.p`
  font-size: clamp(2rem, 4vw, 3.5rem);
  line-height: 1.2;
  font-weight: 400;
  text-align: left;
  margin: 0;
  max-width: 900px;
 color:  rgba(0, 0, 0, 0.8);
  
  @media (max-width: 768px) {
    text-align: left;
    font-size: clamp(1.5rem, 3vw, 2rem);
    max-width: 100%;
  }
`;

const BottomText = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 4rem;
  margin-top: 15vh;
  max-width: 900px;
  margin-left: auto;
  
  @media (max-width: 1024px) {
    gap: 2rem;
    margin-top: 10vh;
  }
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 2rem;
    margin-top: 5vh;
    max-width: 100%;
  }
`;

const BottomTextColumn = styled.p`
  font-size: clamp(0.9rem, 1.2vw, 1.1rem);
  line-height: 1.6;
  color: #999;
  max-width: 400px;
  text-align: left;
  margin: 0;
  
  @media (max-width: 768px) {
    text-align: left;
    max-width: 100%;
  }
`;